@if (itemOptions()?.has("Z")) {
  <!-- Narrow layouts: the note under the description, "No Returns" stays in the corner. Wide: both bottom right, under the price and quantity. -->
  <div custom-cut-details narrow *renderInCartItemResultLayout="LayoutTargets.Summary">
    <span custom-cut-notice>* Subject to additional reel charge</span>
  </div>
  <div custom-cut-details wide *renderInCartItemResultLayout="LayoutTargets.Extended">
    <ideal-product-not-returnable-view [returnable]="false" />
    <span custom-cut-notice>* Subject to additional reel charge</span>
  </div>
}

@if (!pricingError()) {
  <div item-quantity *renderInCartItemResultLayout="LayoutTargets.Summary">
    <ideal-item-price-view
      withLoadingSkeleton
      [isLoading]="pricingLoading()"
      class="big"
      [pricing]="cartItemPricingModel()"
      usePricePer="auto"
      [multiplyBy]="itemQuantity()"
      disableSales="true"
      disableFees="true"
      sizing="compact"
      align="start"
    />
    <div note-label><div>Saved in this cart</div></div>
  </div>
}

<div item-extras *renderInCartItemResultLayout="LayoutTargets.Extended">
  <div>
    @if (pricingError()) {
      <ideal-error [error]="pricingError()" mode="button" />
    } @else {
      <ideal-item-price-view
        withLoadingSkeleton
        [isLoading]="pricingLoading()"
        class="big"
        [pricing]="cartItemPricingModel()"
        usePricePer="auto"
        xsizing="compact"
      />
    }
  </div>
  <div quantity (widthChange)="onQuantityWidthChange($event)">
    <ideal-cart-item-quantity-selector-view
      [(quantity)]="cartItemQuantity"
      [isUpdating]="isItemPending()"
      [pricing]="cartItemPrice()"
      [compact]="compactQuantity()"
    ></ideal-cart-item-quantity-selector-view>
  </div>
</div>
